import {Directive} from '@angular/core'
import {ScriptLoader} from '@sun-finance/utils'
import {SETTING, SettingsRegistry} from '@features/settings/settings-registry'
import {CookieStorageService} from '@features/cookie-consents/cookie-storage.service'
import {COOKIE_CONSENT_LEVEL} from '@features/cookie-consents/contracts'
import {switchMap, take} from 'rxjs'
import {SupportedScripts} from '@features/script-loader'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'

@Directive({
  selector: 'app-google-tag-manager-wrapper, [appGoogleTagManagerWrapper]',
  standalone: true,
})
export class GoogleTagManagerWrapperDirective {

  constructor(loader: ScriptLoader, settings: SettingsRegistry, cookie: CookieStorageService) {
    const key = settings.get(SETTING.GTM_KEY)

    if (!key) {
      return
    }

    cookie
      .onConsent(COOKIE_CONSENT_LEVEL.TRACKING)
      .pipe(
        switchMap(() => loader.load(SupportedScripts.GOOGLE_TAG_MANAGER, { dataAttrs: { key } })),
        take(1),
        takeUntilDestroyed(),
      ).subscribe()
  }

}
